//
//
//
export default {
  name: 'RouteWrapper'
};